import { ObservableArray, View } from "binder"
import { AccountSelectorViewModel } from "../../rawData/accountSelector/accountSelector-viewModel";
import { AccountAndDetailSelectorViewModel, detail } from "./accountAndDetailSelector-viewModel"

export class AccountAndDetailSelectorView extends View<AccountAndDetailSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-AF1B60C7-176F-4CC5-BCAD-CF83394C96DA"
    }
    loadHtml(): string {
        let element = require('./accountAndDetailSelector.html').default;
        let style = require('./accountAndDetailSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set accountSelector(v: AccountSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountSelectorViewModel { return this._accountSelector;} private _accountSelector: AccountSelectorViewModel;
    public set details(v: ObservableArray<detail>) { this._details = v; } public get details(): ObservableArray<detail> { return this._details;} private _details: ObservableArray<detail>;

}
